import LabelField from '@/components/fields/LabelField.vue';
import TextInput from '@/components/fields/TextInput.vue';
import DateInput from '@/components/fields/DateInput.vue';
import MobileField from '@/components/fields/MobileField.vue';
import FieldSet from '@/components/fields/FieldSet.vue';
import ButtonField from '@/components/fields/ButtonField.vue';
import RadioCheckboxGroup from '@/components/fields/RadioCheckboxGroup.vue';
import StoresTab from '@/components/stores/StoresTab.vue';

const form = {
  props: [
    'field',
  ],
  components: {
    LabelField,
    TextInput,
    DateInput,
    MobileField,
    FieldSet,
    ButtonField,
    RadioCheckboxGroup,
    StoresTab,
  },
  data() {
    return {
      hideDobError: true,
      hideMobileError: true,
      hideSubmitError: true,
    };
  },
  methods: {
    validateMobileNumber(value) {
      let number = value;

      if (number && number.indexOf('+') === 0) {
        number = number.replace(/\+/g, '');

        if (number.substring(2, 3) === '0') {
          number = `${number.substring(0, 2)}${number.substring(3)}`;
        }
      }

      return number;
    },
    validateForm(callback) {
      this.hideSubmitError = true;

      this.$validator.validate().then((result) => {
        console.log('validate result:', result);

        if (!result && this.errors.has('dob')) {
          this.hideDobError = false;
        }

        if (!result && this.errors.has('mobile')) {
          this.hideMobileError = false;
        }

        if (!result) {
          this.hideSubmitError = false;
        }

        if (result && callback && typeof callback === 'function') {
          callback();
        }
      });
    },
  },
  provide() {
    return { parentValidator: this.$validator };
  },
};

export { form as default };
